import { z } from 'zod';
import { ESTADOS_DE_INFORMACION, ORIGENES_DE_DATO, } from '../catalogos/nucleo.js';
import { esquemaId } from './comunes.js';
import { esquemaCodigoClinico } from './problema.js';
/**
 * Alergias e intolerancias (F2.1, plan maestro §5.4).
 *
 * Dos cosas distintas:
 * - cada alergia conocida, con su reaccion, severidad y procedencia;
 * - lo que se sabe del conjunto: «niega alergias» no es lo mismo que «no se le
 *   pregunto» ni que «no sabe». Sin esa declaracion, una lista vacia no dice
 *   nada, y eso es lo que tiene que mostrar la interfaz.
 *
 * El texto libre de `historia.alergias` se conserva y se expone con origen
 * `legado` (F2.4); no se convierte en estructurado a ciegas.
 */
export const CATEGORIAS_DE_ALERGIA = ['medicamento', 'alimento', 'ambiental', 'otra'];
export const SEVERIDADES_DE_ALERGIA = ['leve', 'moderada', 'grave', 'desconocida'];
export const ESTADOS_DE_ALERGIA = ['activa', 'inactiva', 'resuelta', 'descartada'];
export const CERTEZAS_DE_ALERGIA = ['confirmada', 'sospechada'];
export const esquemaRegistrarAlergia = z
    .object({
    pacienteId: esquemaId,
    sustancia: z.string().trim().min(2, 'Escriba la sustancia').max(200),
    codigo: esquemaCodigoClinico.optional(),
    categoria: z.enum(CATEGORIAS_DE_ALERGIA),
    reaccion: z.string().trim().max(300).default(''),
    severidad: z.enum(SEVERIDADES_DE_ALERGIA).default('desconocida'),
    estado: z.enum(ESTADOS_DE_ALERGIA).default('activa'),
    certeza: z.enum(CERTEZAS_DE_ALERGIA).default('sospechada'),
    origen: z.enum(ORIGENES_DE_DATO).default('profesional'),
    nota: z.string().trim().max(500).default(''),
})
    .strict();
/**
 * Lo que se sabe de las alergias en conjunto. `afirmado` = tiene alergias (y
 * entonces la lista dice cuales); `negado` = niega alergias conocidas.
 */
export const esquemaDeclararAlergias = z
    .object({
    pacienteId: esquemaId,
    estado: z.enum(ESTADOS_DE_INFORMACION),
    origen: z.enum(ORIGENES_DE_DATO).default('profesional'),
})
    .strict();
export const FUENTES_LEGADAS_DE_ALERGIAS = ['ficha-paciente', 'historia-clinica'];
export const esquemaActualizarAlergia = z
    .object({
    versionEsperada: z.number().int().min(0),
    reaccion: z.string().trim().max(300).optional(),
    severidad: z.enum(SEVERIDADES_DE_ALERGIA).optional(),
    estado: z.enum(ESTADOS_DE_ALERGIA).optional(),
    certeza: z.enum(CERTEZAS_DE_ALERGIA).optional(),
    nota: z.string().trim().max(500).optional(),
})
    .strict();
//# sourceMappingURL=alergia.js.map